import { render, staticRenderFns } from "./LessonMediaGrid.vue?vue&type=template&id=2bc03768"
import script from "./LessonMediaGrid.vue?vue&type=script&lang=js"
export * from "./LessonMediaGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports